import queryClient from './queryClient';

function getFeedDetailedCached() {
  return queryClient.getQueriesData({
    predicate: (q) => Array.isArray(q.queryKey) && q.queryKey[0] === 'v1' && q.queryKey[1] === 'feed-detailed',
  });
}

function updateFeedDetailedCached(type, updatedData) {
  const feedCached = getFeedDetailedCached();

  feedCached.forEach(([feedQueryKey, queryData]) => {
    if (queryData?.pages) {
      const updatedPages = queryData.pages.map((page) => {
        const updatedItems = page.items.map((item) => {
          if (item.type === type && item.id === updatedData.id) {
            return {
              ...item,
              value: {
                ...item.value,
                ...updatedData,
              },
            };
          }
          return item;
        });

        return {
          ...page,
          items: updatedItems,
        };
      });

      queryClient.setQueryData(feedQueryKey, {
        ...queryData,
        pages: updatedPages,
      });
    }
  });
}

export default { getFeedDetailedCached, updateFeedDetailedCached };
